import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  active: 0,
  loading: false,
  error: null,
};

const ActiveAgents = createSlice({
  name: "active",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.active = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.active = null;
    },
  },
});

// Actions
export const { requestStart, ApiSuccess, requestFailure } =
  ActiveAgents.actions;

export default ActiveAgents.reducer;
